import actionTypes from '../constants/action-types';

const registerInterruptionPoint = (actionType, matcher) => ({
  type: actionTypes.REGISTER_INTERRUPTION_POINT,
  payload: {
    actionType,
    matcher,
  },
});

export default registerInterruptionPoint;
